import React from 'react'
import { Container, ContainerInterno, Texto } from './Styled'

export default function Rodape () {

	return (
		<Container>
			<ContainerInterno>
				<Texto><strong>Condição exclusiva para alunos da Estratégia Concursos.</strong> Válida para quem realizou compras entre 01/07/2025 e 30/05/2026, exceto assinaturas Platinum, Vitalícios e Corujinha Social. O desconto exclusivo de aluno é aplicado somente sobre as assinaturas Básica e Premium. Não são contabilizados para o cálculo do desconto: Assinatura Platinum, Discursivas com correção, Recurso de provas, Coaching, Mentorias e Estudo Acompanhado. Oferta válida somente até 15/07/2026. Valores e condições podem variar conforme o lote.</Texto>
			</ContainerInterno>
		</Container>
	)
}
